export default function Preloader() {
    return (
        <div className="min-h-screen bg-background flex items-center justify-center">
            <div className="flex flex-col items-center gap-4">
                <img
                    src="/logo.png"
                    alt="Genesis Recovery AI"
                    className="h-16 w-auto object-contain animate-pulse"
                />
                <div className="h-1 w-44 overflow-hidden rounded-full bg-slate-200">
                    <div className="h-full w-1/2 animate-pulse rounded-full bg-slate-900" />
                </div>
                <p className="text-sm text-slate-600">Loading...</p>
            </div>
        </div>
    );
}
